import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import ActiveReadersChart from "./ActiveReadersChart";
import FiguresChart from "./FiguresChart";
import { ProgressChart } from "./ProgressChart";

const PartnerStats = () => {
  return (
    <Box>
      <SimpleGrid columns={3} spacing={4}>
        <Box>
          <Text textAlign="center" fontWeight="bold">
            Active readers
          </Text>
          <ActiveReadersChart />
        </Box>
        <Box>
          <Text textAlign="center" fontWeight="bold">
            Your readers progress
          </Text>
          <ProgressChart />
        </Box>
        <Box>
          <FiguresChart />
        </Box>
      </SimpleGrid>
    </Box>
  );
};

export default PartnerStats;
